import { SoundBoard } from './pages/SoundBoard';
import { TitleBar } from './components/TitleBar'
import './App.css';

function App() {
  return (
    <div className="App">
      <TitleBar/>
      <SoundBoard/>
    </div>
  );
}

export default App;
